var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHideCollection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8438_595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8086 15.2874C36.3422 12.8861 34.4924 10.7411 32.3327 8.93764L36.881 4.38935C37.5043 3.74403 37.4864 2.71572 36.8411 2.09248C36.2116 1.48447 35.2136 1.48447 34.5841 2.09248L29.6378 7.04524C26.5716 5.22404 23.0661 4.27476 19.5 4.30004C9.44329 4.30004 3.71242 11.1843 1.19138 15.2875C-0.397127 17.8568 -0.397127 21.1033 1.19138 23.6726C2.65783 26.074 4.50759 28.219 6.66725 30.0224L2.11896 34.5707C1.47365 35.1939 1.45575 36.2223 2.07899 36.8676C2.70222 37.5129 3.73062 37.5308 4.37586 36.9075C4.38941 36.8945 4.40274 36.8811 4.41583 36.8676L9.37347 31.9099C12.4359 33.7309 15.9371 34.6817 19.5 34.66C29.5566 34.66 35.2875 27.7758 37.8085 23.6726C39.3971 21.1033 39.3971 17.8568 37.8086 15.2874ZM9.75365 19.48C9.74444 14.1062 14.0932 9.7424 19.4671 9.73319C21.5003 9.72968 23.4836 10.3633 25.1383 11.5449L22.7797 13.9035C21.7895 13.3064 20.6563 12.9881 19.5 12.9825C15.9115 12.9825 13.0025 15.8915 13.0025 19.48C13.0081 20.6363 13.3264 21.7695 13.9235 22.7597L11.5649 25.1183C10.3871 23.4741 9.75373 21.5025 9.75365 19.48ZM19.5 29.2264C17.4776 29.2263 15.5059 28.593 13.8618 27.4152L16.2204 25.0566C17.2106 25.6537 18.3438 25.972 19.5 25.9776C23.0885 25.9776 25.9976 23.0685 25.9976 19.48C25.992 18.3238 25.6737 17.1905 25.0766 16.2004L27.4352 13.8417C30.5581 18.215 29.5445 24.2918 25.1713 27.4147C23.5166 28.5963 21.5333 29.2299 19.5 29.2264Z",
    fill: "#8F9298",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8438_595"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideCollection);
export default __webpack_public_path__ + "static/media/hide-collection.dc4cd2ece00df308521cf0c3f8ab423d.svg";
export { ForwardRef as ReactComponent };